// removed by extract-text-webpack-plugin
module.exports = {"expansion":"expansion--expansion--3r6WRI9O","is-open":"expansion--is-open--1IhCsBVU","isOpen":"expansion--is-open--1IhCsBVU","action":"expansion--action--30wT-Doh","header":"expansion--header--MLSkzq8e","button":"expansion--button--ZXpyfuWs"};


//////////////////
// WEBPACK FOOTER
// ./src/baseComponents/components/Expansion/expansion.scss
// module id = 630
// module chunks = 0